import store from '../../../store/store';

export const componentKey = 'PATIENTDASHBOARD_SECTION';

const { actions } = store.reducerManager.add({
	key: componentKey,
	addedReducers: {
		setPatientId: (state, action) => {
			state.currentPatientId = action.payload;
		},
		setPatientData: (state, action) => {
			state.patientData = action.payload;
		},
		setIsOpenDeletePopup: (state, action) => {
			state.isOpenDeletePopup = action.payload;
		},
		setSelectedBundle: (state, action) => {
			state.selectedBundle = action.payload
		},
		setBundlePushResponse: (state, action) => {
			state.bundlePushResponse = action.payload
		},
		setBundleSaveResponse: (state, action) => {
			state.bundleSaveResponse = action.payload
		},
		setBundlePushError: (state, action) => {
			state.bundlepushError = action.payload
		},
		setConsetRequestData: (state, action) => {
			state.consentRequestData = action.payload
		},
		setHUInotifyData: (state, action) => {
			state.huiNotifyData = action.payload
		},
		setDecryptedData: (state, action) => {
			state.decryptedData = action.payload
		},
		setBundlesData: (state, action) => {
			state.bundlesData = action.payload
		},
		setConsentList: (state, action) => {
			state.consentList = action.payload
		},
		setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },
	},
	initialReducerState: {
		currentPatientId: '',
		patientData: {},
		isOpenDeletePopup: false,
		selectedBundle: null,
		bundlePushResponse: {},
		bundleSaveResponse: {},
		bundlepushError: {},
		consentRequestData:null,
		huiNotifyData: null,
		decryptedData: [],
		bundlesData: [],
		consentList: [],
		paginationState: { pageNumber: 1, limit: 10, total: 0, search: "", status: "All", orderBy: "desc", sortBy: "" },
	},
});

export const { 
	setPatientId, 
	setPatientData, 
	setIsOpenDeletePopup, 
	setSelectedBundle, 
	setBundlePushResponse, 
	setBundleSaveResponse,
	setBundlePushError, 
	setConsetRequestData, 
	setHUInotifyData, 
	setDecryptedData, 
	setBundlesData, 
	setConsentList, 
	setSelectedPatientList,
	setPaginationState
} = actions;
